/**
 * Where an idea's work runs, and how it moves after approval (ER-145).
 *
 * - `computer`: the interview, blueprint and build run on one of the person's
 *   paired computers.
 * - `cloud`: the interview runs on the AI key on CompBox's server, and the
 *   blueprint and build run as CompBox cloud runs.
 *
 * Stored on the idea (EpicRequest.runsOn). Null means it was never chosen: the
 * idea behaves as before (a computer, or wherever its runs were started).
 */
export const IDEA_RUNS_ON = ["computer", "cloud"];
/**
 * How an idea moves after you approve it. Each person picks their default in
 * Settings (User.ideaModeDefault); null means Manual.
 */
export const IDEA_MODES = ["manual", "autopilot"];
/** A stored value as an IdeaRunsOn, or null when unset or unknown. */
export function toIdeaRunsOn(raw) {
    return raw === "computer" || raw === "cloud" ? raw : null;
}
/** A stored value as an IdeaMode; anything unset or unknown is Manual. */
export function toIdeaMode(raw) {
    return raw === "autopilot" ? "autopilot" : "manual";
}
//# sourceMappingURL=idea-run-settings.js.map